import { z } from 'zod';
export const printAccountBadgesBulkActionName = 'printAccountBadges';
export const printAccountBadgesBulkActionRequestSchema = z.object({
    badgeId: z.string().uuid(),
    filter: z.custom(),
});
